import { MenuPosition } from 'components/shared/menu/menu-content';

const marginFromContent = 4;

export function calculateMenuPosition(triggerRect: DOMRect, menuRect: DOMRect, position: MenuPosition) {
  const { left, top, height, width } = triggerRect;
  const { width: menuWidth, height: menuHeight } = menuRect;

  // Open below the trigger, flipping above it when that would run past the viewport bottom.
  const below = top + height + marginFromContent;
  const y = below + menuHeight > window.innerHeight ? top - menuHeight - marginFromContent : below;

  switch (position) {
    case 'left':
      return { x: left, y };
    case 'right':
      return { x: left + width - menuWidth, y };
    case 'center':
      return { x: left + width / 2 - menuWidth / 2, y };
    default:
      throw Error(`${position} must be implemented`);
  }
}
